module.exports = __webpack_public_path__ + "img/vielmobil.195c77f9.png";